// Device 自定义下拉框 — 事件委托（统一入口，兼容主页 & quickview 弹窗）
if (!window.__deviceDropdownInit) {
  window.__deviceDropdownInit = true;
  document.addEventListener('click', function(e) {
    // 点击 trigger → 展开/收起
    var trigger = e.target.closest('.g-product-option--dropdown .hs-filter-trigger');
    if (trigger) {
      e.stopPropagation();
      var wrapper = trigger.closest('.hs-filter-select');
      if (!wrapper) return;
      var dropdown = wrapper.querySelector('.hs-filter-dropdown');
      if (!dropdown) return;
      var isOpen = dropdown.classList.contains('open');

      document.querySelectorAll('.g-product-option--dropdown .hs-filter-dropdown.open').forEach(function(dd) {
        dd.classList.remove('open');
        var prev = dd.previousElementSibling;
        if (prev) prev.classList.remove('active');
      });

      if (!isOpen) {
        dropdown.classList.add('open');
        trigger.classList.add('active');
      }
      return;
    }

    // 点击选项 → 选中并跳转
    var opt = e.target.closest('.g-product-option--dropdown .hs-filter-option');
    if (opt) {
      var wrapper = opt.closest('.hs-filter-select');
      if (!wrapper) return;
      var dropdown = wrapper.querySelector('.hs-filter-dropdown');
      var trigger2 = wrapper.querySelector('.hs-filter-trigger');
      var productUrl = opt.getAttribute('data-product-url');

      dropdown.querySelectorAll('.hs-filter-option').forEach(function(o) { o.classList.remove('selected'); });
      opt.classList.add('selected');

      if (trigger2) {
        trigger2.textContent = opt.textContent;
        trigger2.classList.remove('active');
      }
      dropdown.classList.remove('open');

      if (productUrl) {
        window.location.href = productUrl;
      }
      return;
    }

    // 点击下拉框外部 → 关闭所有
    if (!e.target.closest('.g-product-option--dropdown .hs-filter-select')) {
      document.querySelectorAll('.g-product-option--dropdown .hs-filter-dropdown.open').forEach(function(dd) {
        dd.classList.remove('open');
        var prev = dd.previousElementSibling;
        if (prev) prev.classList.remove('active');
      });
    }
  });
}

if (!customElements.get('variant-picker-compose')) {
  class VariantPickerCompose extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        setTimeout(() => this.init(), 200);
      } else {
        this.init();
      }
    }

    init() {
      this.selectors = {
        error: '.g-product-form-message',
        variantIdInput: '[name="id"]',
        optionNodes: ['.g-product-option--node'],
      };
      this.domNodes = queryDomNodes(this.selectors, this);
      this.composeValue = this.getComposeByJson();

      const { productId, sectionId, productUrl, hasOnlyDefaultVariant, showFeaturedMedia } = this.dataset;

      this.productId = productId;
      this.sectionId = sectionId;
      this.productUrl = productUrl;
      this.hasOnlyDefaultVariant = hasOnlyDefaultVariant === 'true';
      this.showFeaturedMedia = showFeaturedMedia === 'true';
      this.initOptionSwatches();
    }
    getComposeByJson() {
      try {
        const composeValueElement = this.querySelector("#composeValue[type='application/json']");
        if (!composeValueElement) {
          throw new Error('Fallback product data element not found.');
        }
        return JSON.parse(composeValueElement.textContent);
      } catch (error) {
        console.error('Error loading fallback product data:', error);
        // Return a default value or further handle the error as needed
      }
    }
    initOptionSwatches() {
      const { _colorSwatches = [], _imageSwatches = [] } = window.GkifySettings;
      if (this.domNodes.optionNodes) {
        this.domNodes.optionNodes.forEach((optNode) => {
          const { optionType, optionPosition, value: optionValue } = optNode.dataset;
          const optionValueLowerCase = optionValue && optionValue.toLowerCase();
          var variantImage = null;
          // const variantToShowSwatchImage = this.variantData.find((v) => v[`option${optionPosition}`] === optionValue);
          // const variantImage =
          //   variantToShowSwatchImage &&
          //   variantToShowSwatchImage.featured_image &&
          //   variantToShowSwatchImage.featured_image.src
          //     ? getSizedImageUrl(variantToShowSwatchImage.featured_image.src, '100x')
          //     : null;
          const customImage = _imageSwatches.find((i) => i.key === optionValueLowerCase);
          const customColor = _colorSwatches.find((c) => c.key === optionValueLowerCase);

          if (variantImage || (customImage && customImage.value)) {
            const labelElement = optNode.querySelector('label');
            if (labelElement) {
              labelElement.classList.add('has-bg-img');
            }
          }
          const labelElement = optNode.querySelector('label');
          if (labelElement) {
            labelElement.classList.remove('option-loading');

            switch (optionType) {
              case 'default':
              case 'image':
                labelElement.style.backgroundImage = `url(${(customImage && customImage.value) || variantImage || ''})`;
                break;
              case 'color':
                labelElement.style.background = (customColor && customColor.value) || optionValueLowerCase;
                if (customImage && customImage.value) {
                  labelElement.style.backgroundImage = `url(${customImage.value})`;
                }
                break;
              default:
                break;
            }
          }
        });
      }
    }
  }

  customElements.define('variant-picker-compose', VariantPickerCompose);
}
